export type IResetLastPopedPopover = IDCA.IGenericFunc;

export const resetLastPopedPopover = () => {
  if (
    window.DexeroCoreApp.lastPopedPopoverContentPosition &&
    window.DexeroCoreApp.lastPopedPopoverScrollTable &&
    (window.DexeroCoreApp.lastPopedPopoverScrollTable as IjQueryElm).length
  ) {
    $(window.DexeroCoreApp.lastPopedPopoverScrollTable).off(
      'scroll',
      window.DexeroCoreApp.positionLastPopedPopover
    );
  }
  $(window).off('scroll', window.DexeroCoreApp.positionLastPopedPopover);
  $(window).off('resize', window.DexeroCoreApp.positionLastPopedPopover);
};
